exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ha-p {\r\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),\r\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\r\n  border: 1px solid #cccccc;\r\n  background-color: rgba(255, 255, 255, 0.95);\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n}\r\n.ha-pc {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n    padding: 16px;\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    padding: 24px 24px;\r\n}\r\n", ""]);

// exports
